import React from 'react';
import { 
  List, 
  ListItem, 
  ListItemText, 
  ListItemAvatar, 
  Avatar, 
  Typography, 
  useTheme, 
  Divider, 
  Chip,
  Box
} from '@mui/material';
import { 
  MoveUp, 
  MoveDown, 
  CheckCircle, 
  Pending, 
  Cancel
} from '@mui/icons-material';
import { tokens } from '../../../theme';

const StockMovementsList = ({ movements }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Status configuration
  const statusConfig = {
    'draft': {
      icon: <Pending />,
      color: colors.grey[500],
      label: 'Draft'
    },
    'assigned': {
      icon: <Pending />,
      color: colors.blueAccent[500],
      label: 'Assigned'
    },
    'done': {
      icon: <CheckCircle />,
      color: colors.greenAccent[500],
      label: 'Done'
    },
    'cancelled': {
      icon: <Cancel />,
      color: colors.redAccent[500],
      label: 'Cancelled'
    }
  };

  // Empty state
  if (movements.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="300px">
        <Typography color={colors.grey[500]}>No stock movements found</Typography>
      </Box>
    );
  }

  return (
    <List sx={{ width: '100%', maxHeight: '400px', overflow: 'auto' }}>
      {movements.map((movement, index) => (
        <React.Fragment key={movement._id || index}>
          <ListItem alignItems="flex-start">
            <ListItemAvatar>
              <Avatar 
                sx={{ 
                  bgcolor: movement.fromLocation === 'stock' ? colors.redAccent[500] : colors.greenAccent[500]
                }}
              >
                {movement.fromLocation === 'stock' ? <MoveUp /> : <MoveDown />}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography 
                    variant="h5" 
                    color={colors.grey[100]}
                    sx={{ mr: 1 }}
                  >
                    {movement.productId?.name || 'Unknown Product'}
                  </Typography>
                  <Chip 
                    icon={statusConfig[movement.state]?.icon}
                    label={statusConfig[movement.state]?.label}
                    size="small"
                    sx={{ 
                      bgcolor: statusConfig[movement.state]?.color,
                      color: colors.grey[100]
                    }}
                  />
                </Box>
              }
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    color={colors.grey[300]}
                  >
                    {`Quantity: ${movement.quantity} ${movement.productId?.unitName || ''}`}
                  </Typography>
                  <br />
                  <Typography
                    component="span"
                    variant="body2"
                    color={colors.grey[400]}
                  >
                    {`${movement.fromLocation} → ${movement.toLocation}`}
                  </Typography>
                  <br />
                  <Typography
                    component="span"
                    variant="body2"
                    color={colors.grey[400]}
                  >
                    {`Move ID: ${movement.moveId}${movement.anrId ? ` | ANR: ${movement.anrId}` : ''}`}
                  </Typography>
                  <br />
                  <Typography
                    component="span"
                    variant="body2"
                    color={colors.grey[500]}
                  >
                    {new Date(movement.moveDate).toLocaleString()}
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
          {index < movements.length - 1 && (
            <Divider variant="inset" component="li" />
          )}
        </React.Fragment>
      ))}
    </List>
  );
};

export default StockMovementsList;